import css from './index.module.scss';
import Series from './Series';
import { useGlobal } from '@/utils/useGlobal';

export default function LPower() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');
    const seriesData: any[] = [
        {
            key: 'river',
            title: t('secL_power_river_title'),
            desc: t('secL_power_river_desc'),
            img: '/responsive/picture/vanlife/11_1_1.jpg',
            tables: [
                {
                    tableTitle: t('secL_power_river_table1_title'),
                    tableHead: [
                        {
                            text: '',
                            link: '',
                        },
                        {
                            text: t('secL_power_river_table1_head1'),
                            link: t('secL_power_river_table1_head1_link'),
                        },
                        {
                            text: t('secL_power_river_table1_head2'),
                            link: t('secL_power_river_table1_head2_link'),
                        },
                        {
                            text: t('secL_power_river_table1_head3'),
                            link: t('secL_power_river_table1_head3_link'),
                        },
                    ],
                    tableContent: [
                        [
                            t('secL_power_table_menu1'),
                            t('secL_power_river_table1_content_row1_col1'),
                            t('secL_power_river_table1_content_row1_col2'),
                            t('secL_power_river_table1_content_row1_col3'),
                        ],
                        [
                            t('secL_power_table_menu2'),
                            t('secL_power_river_table1_content_row2_col1'),
                            t('secL_power_river_table1_content_row2_col2'),
                            t('secL_power_river_table1_content_row2_col3'),
                        ],
                        [
                            t('secL_power_table_menu3'),
                            t('secL_power_river_table1_content_row3_col1'),
                            t('secL_power_river_table1_content_row3_col2'),
                            t('secL_power_river_table1_content_row3_col3'),
                        ],
                        [
                            t('secL_power_table_menu4'),
                            t('secL_power_river_table1_content_row4_col1'),
                            t('secL_power_river_table1_content_row4_col2'),
                            t('secL_power_river_table1_content_row4_col3'),
                        ],
                        [
                            t('secL_power_table_menu5'),
                            t('secL_power_river_table1_content_row5_col1'),
                            t('secL_power_river_table1_content_row5_col2'),
                            t('secL_power_river_table1_content_row5_col3'),
                        ],
                    ],
                },
                {
                    tableTitle: t('secL_power_river_table2_title'),
                    tableContent: [
                        [
                            t('secL_power_river_table2_menu1'),
                            t('secL_power_river_table2_content_row1_col1'),
                            t('secL_power_river_table2_content_row1_col2'),
                            t('secL_power_river_table2_content_row1_col3'),
                        ],
                        [
                            t('secL_power_river_table2_menu2'),
                            t('secL_power_river_table2_content_row2_col1'),
                            t('secL_power_river_table2_content_row2_col2'),
                            t('secL_power_river_table2_content_row2_col3'),
                        ],
                        [
                            t('secL_power_river_table2_menu3'),
                            t('secL_power_river_table2_content_row3_col1'),
                            t('secL_power_river_table2_content_row3_col2'),
                            t('secL_power_river_table2_content_row3_col3'),
                        ],
                        [
                            t('secL_power_river_table2_menu4'),
                            t('secL_power_river_table2_content_row4_col1'),
                            t('secL_power_river_table2_content_row4_col2'),
                            t('secL_power_river_table2_content_row4_col3'),
                        ],
                        [
                            t('secL_power_river_table2_menu5'),
                            t('secL_power_river_table2_content_row5_col1'),
                            t('secL_power_river_table2_content_row5_col2'),
                            t('secL_power_river_table2_content_row5_col3'),
                        ],
                    ],
                },
            ],
            note: '',
        },
        {
            key: 'delta',
            title: t('secL_power_delta_title'),
            desc: t('secL_power_delta_desc'),
            img: '/responsive/picture/vanlife/11_1_2.jpg',
            tables: [
                {
                    tableTitle: t('secL_power_delta_table1_title'),
                    tableHead: [
                        {
                            text: '',
                            link: '',
                        },
                        {
                            text: t('secL_power_delta_table1_head1'),
                            link: t('secL_power_delta_table1_head1_link'),
                        },
                        {
                            text: t('secL_power_delta_table1_head2'),
                            link: t('secL_power_delta_table1_head2_link'),
                        },
                        {
                            text: t('secL_power_delta_table1_head3'),
                            link: t('secL_power_delta_table1_head3_link'),
                        },
                    ],
                    tableContent: [
                        [
                            t('secL_power_table_menu1'),
                            t('secL_power_delta_table1_content_row1_col1'),
                            t('secL_power_delta_table1_content_row1_col2'),
                            t('secL_power_delta_table1_content_row1_col3'),
                        ],
                        [
                            t('secL_power_table_menu2'),
                            t('secL_power_delta_table1_content_row2_col1'),
                            t('secL_power_delta_table1_content_row2_col2'),
                            t('secL_power_delta_table1_content_row2_col3'),
                        ],
                        [
                            t('secL_power_table_menu3'),
                            t('secL_power_delta_table1_content_row3_col1'),
                            t('secL_power_delta_table1_content_row3_col2'),
                            t('secL_power_delta_table1_content_row3_col3'),
                        ],
                        [
                            t('secL_power_table_menu4'),
                            t('secL_power_delta_table1_content_row4_col1'),
                            t('secL_power_delta_table1_content_row4_col2'),
                            t('secL_power_delta_table1_content_row4_col3'),
                        ],
                        [
                            t('secL_power_table_menu5'),
                            t('secL_power_delta_table1_content_row5_col1'),
                            t('secL_power_delta_table1_content_row5_col2'),
                            t('secL_power_delta_table1_content_row5_col3'),
                        ],
                    ],
                },
                {
                    tableTitle: t('secL_power_delta_table2_title'),
                    tableContent: [
                        [
                            t('secL_power_delta_table2_menu1'),
                            t('secL_power_delta_table2_content_row1_col1'),
                            t('secL_power_delta_table2_content_row1_col2'),
                            t('secL_power_delta_table2_content_row1_col3'),
                        ],
                        [
                            t('secL_power_delta_table2_menu2'),
                            t('secL_power_delta_table2_content_row2_col1'),
                            t('secL_power_delta_table2_content_row2_col2'),
                            t('secL_power_delta_table2_content_row2_col3'),
                        ],
                        [
                            t('secL_power_delta_table2_menu3'),
                            t('secL_power_delta_table2_content_row3_col1'),
                            t('secL_power_delta_table2_content_row3_col2'),
                            t('secL_power_delta_table2_content_row3_col3'),
                        ],
                        [
                            t('secL_power_delta_table2_menu4'),
                            t('secL_power_delta_table2_content_row4_col1'),
                            t('secL_power_delta_table2_content_row4_col2'),
                            t('secL_power_delta_table2_content_row4_col3'),
                        ],
                        [
                            t('secL_power_delta_table2_menu5'),
                            t('secL_power_delta_table2_content_row5_col1'),
                            t('secL_power_delta_table2_content_row5_col2'),
                            t('secL_power_delta_table2_content_row5_col3'),
                        ],
                        [
                            t('secL_power_delta_table2_menu6'),
                            t('secL_power_delta_table2_content_row6_col1'),
                            t('secL_power_delta_table2_content_row6_col2'),
                            t('secL_power_delta_table2_content_row6_col3'),
                        ],
                    ],
                },
            ],
            note: t.rich('secL_power_delta_table2_note', {
                a: (text: string) => (
                    <Link className="note-link" href={t('secL_power_delta_table2_note_link')}>
                        {text}
                    </Link>
                ),
            }),
        },
    ];
    return (
        <div id="vanlife-L-power" className={`vanlife-L-power ${css['vanlife-L-power']}`}>
            <h3 className="title">{t('secL_power_title')}</h3>
            <p className="text desc-h3">{t('secL_power_desc')}</p>
            {seriesData?.map((data: any, k: number) => (
                <Series key={k} data={data} />
            ))}
        </div>
    );
}
